// What the candidate portal says after a compliance officer edits the checklist
// a candidate is already part-way through.
//
// Centralised here rather than written inline for the reason alternateEmailCopy
// gives: a reword is one line instead of a hunt through a 1000-line page, and
// the copy decisions below are assertable without rendering the whole portal.
//
// Four states, because one edit can do either, both or neither:
//
//   added only    — they have something new to go and find
//   removed only  — one less thing to do, and nothing to act on
//   both          — the common case after a real checklist rework
//   neither       — no notice at all
//
// The old copy was a single sentence built for the removed-only case ("The
// requirements changed — one document is no longer needed"). It could not say
// "and here are two more we now need", which is the only half of a checklist
// edit the candidate actually has to act on.

export const CHANGE_NOTICE_HEADING = "Your document list has been updated";

export const ADDED_HEADING = "Now needed from you";
export const REMOVED_HEADING = "No longer needed";

// Said as an instruction, not as news. An added document is a task: they have to
// find it, scan it and send it, and the sentence should read like the thing they
// have to do.
export const addedLead = (count) =>
  count === 1 ? "There is one more document to send. You can upload it below." : `There are ${count} more documents to send. You can upload them below.`;

// ⚠️ PLACEHOLDER COPY, pending CTO sign-off on document erasure.
//
// This sentence tells the candidate their file has been DELETED. As of this
// change that is not what happens: re-apply soft-deletes the document row
// (is_deleted / is_active cleared, delete_reason tagged) and the bytes stay in
// `compliance_documents.file_data` indefinitely. Nothing in the compliance
// domain ever erases them — there is no purge job, no retention sweep and no
// erasure endpoint — and repository.soft_delete_document's docstring argues for
// keeping them ("the bytes are the candidate's evidence and an audit trail
// points at this row").
//
// Written this way on the user's explicit instruction, twice given, for a demo.
// Whoever picks this up next: it is a data-protection statement to a data
// subject on a public page, so it is either made true or reworded — it should
// not simply be inherited.
//
// To make it TRUE, the work is roughly: a migration making file_data nullable
// plus a bytes_erased_at column, an erase_document_bytes helper beside
// soft_delete_document, a call in the removal loop of commit_checklist_reapply,
// the REMOVE_BY_CHECKLIST audit row extended to record the erasure, and an audit
// of every reader that assumes bytes exist.
//
// To make it HONEST WITHOUT ERASURE, this becomes something like:
//   "It is no longer part of your checklist and will not be reviewed."
export const REMOVED_LEAD_DELETED =
  "We have deleted these from our records, so nothing you sent for them is kept. " + "There is nothing for you to do and you do not need to send them again.";

export const EMPTY_SECTION_FALLBACK = "Other documents";
